import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, AnimatePresence } from 'framer-motion';
import LanguageSwitcher from './LanguageSwitcher';

const MobileMenu = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <MobileMenuContainer>
      <HamburgerButton onClick={toggleMenu}>
        <HamburgerIcon isOpen={isOpen}>
          <span></span>
        </HamburgerIcon>
      </HamburgerButton>

      <AnimatePresence>
        {isOpen && (
          <MenuContent
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
          >
            <MobileNavLink to="/affiliate" onClick={toggleMenu}>
              {t('navigation.affiliate.home')}
            </MobileNavLink>
            <MobileNavLink to="/affiliate/dashboard" onClick={toggleMenu}>
              {t('navigation.affiliate.dashboard')}
            </MobileNavLink>
            <MobileNavLink to="/" onClick={toggleMenu}>
              {t('navigation.affiliate.mainSite')}
            </MobileNavLink>
            <MobileNavLink to="/affiliate/terms" onClick={toggleMenu}>
              {t('navigation.affiliate.terms')}
            </MobileNavLink>
            <MobileLangSwitcher>
              <MobileSwitcherLabel>{t('navigation.language.switch')}:</MobileSwitcherLabel>
              <LanguageSwitcher />
            </MobileLangSwitcher>
          </MenuContent>
        )}
      </AnimatePresence>
    </MobileMenuContainer>
  );
};

const MobileMenuContainer = styled.div`
  display: none;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    display: block;
  }
`;

const HamburgerButton = styled.button`
  background: none;
  border: none;
  padding: 10px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const HamburgerIcon = styled.div`
  width: 24px;
  height: 18px;
  position: relative;
  transform: rotate(0deg);
  transition: 0.5s ease-in-out;
  
  span {
    display: block;
    position: absolute;
    height: 2px;
    width: 100%;
    background: ${({ theme }) => theme.affiliate.colors.text.contrast.dark};
    border-radius: 2px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: 0.25s ease-in-out;
    
    &:before, &:after {
      content: '';
      position: absolute;
      height: 2px;
      width: 100%;
      background: ${({ theme }) => theme.affiliate.colors.text.contrast.dark};
      border-radius: 2px;
      transition: 0.25s ease-in-out;
    }
    
    &:before {
      top: ${({ isOpen }) => (isOpen ? '0' : '-8px')};
      transform: ${({ isOpen }) => (isOpen ? 'rotate(135deg)' : 'rotate(0)')};
    }
    
    &:after {
      top: ${({ isOpen }) => (isOpen ? '0' : '8px')};
      transform: ${({ isOpen }) => (isOpen ? 'rotate(-135deg)' : 'rotate(0)')};
    }
  }
  
  span {
    opacity: ${({ isOpen }) => (isOpen ? '0' : '1')};
  }
`;

const MenuContent = styled(motion.div)`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: ${({ theme }) => theme.affiliate.gradients.dark};
  padding: 0;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 10;
`;

const MobileNavLink = styled(Link)`
  color: ${({ theme }) => theme.affiliate.colors.text.contrast.dark};
  text-decoration: none;
  padding: 15px 20px;
  font-size: 1.1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: background ${({ theme }) => theme.affiliate.animationDuration};
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

const MobileLangSwitcher = styled.div`
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

const MobileSwitcherLabel = styled.span`
  color: ${({ theme }) => theme.affiliate.colors.text.contrast.dark};
  font-size: 0.9rem;
  opacity: 0.8;
`;

export default MobileMenu;